<ng-container *ngIf="showCard && !showInModal; else noCardView">
  <app-card [cardClasses]="'mt-7'" [header]="true" cardBodyClasses="pt-0" cardHeaderTitle="Ringkasan Harga">
    <ng-container *ngIf="data | async as value" cardBody>
      <div class="px-4 py-6 border-bottom">
        <div class="d-flex font-14 justify-content-between">
          <p class="text-capitalize fw-bold mb-0">Metode Pembayaran</p>
          <p class="text-capitalize fw-bold mb-0">{{ value.payment_method_string }}</p>
        </div>
      </div>

      <div class="px-4 py-6 border-bottom">
        <ng-container *ngFor="let item of value.product_invoice_list; let i = index">
          <div class="mb-5 font-14">
            <div class="d-flex justify-content-between text-gray-900">
              <p class="">
                <span>{{ item.product_name }}</span>
                <span *ngIf="item.total_weight_unit">- {{ item.total_weight_unit }}</span>
              </p>
              <p class="">{{ utilities.toRupiah(item.total_base_price) }}</p>
            </div>
            <div *ngIf="item.discount_percentage" class="d-flex justify-content-between text-gray-900 font-12">
              <p class="ms-3">{{ 'Sales Diskon ' + item.discount_percentage + '%' }}</p>
              <p class="text-danger">{{ '-' + utilities.toRupiah(item.discount_price) }}</p>
            </div>
          </div>
        </ng-container>
        <div class="d-flex justify-content-between font-14 text-gray-900">
          <p class="text-capitalize fw-bold mb-0">Subtotal</p>
          <p class="fw-bold mb-0">{{ utilities.toRupiah(value.subtotal_invoice) }}</p>
        </div>
      </div>

      <!-- CBD DISCOUNT SECTION -->
      <div *ngIf="value.cbd_discount" class="px-4 py-6 border-bottom">
        <div class="d-flex justify-content-between font-14 text-gray-900">
          <p class="mb-0">{{ 'Discount Cash Before Delivery ' + '(' + value.cbd_discount + '%)' }}</p>
          <p class="mb-0 text-danger">{{ '-' + utilities.toRupiah(value.cbd_discount_price) }}</p>
        </div>
      </div>

      <div class="px-4 py-6">
        <div class="d-flex font-14 justify-content-between">
          <p class="fw-bold mb-0">Total Harga <span class="text-gray-600 fw-normal">(Include PPN)</span></p>
          <p class="fw-bold mb-0">{{ utilities.toRupiah(value.total_invoice) }}</p>
        </div>
      </div>
    </ng-container>
  </app-card>
</ng-container>

<ng-template #noCardView>
  <ng-container *ngIf="data | async as value" cardBody>
    <div class="px-4 py-6 border-bottom">
      <div class="d-flex font-14 justify-content-between">
        <p class="text-capitalize fw-bold mb-0">Metode Pembayaran</p>
        <p class="text-capitalize fw-bold mb-0">{{ value.payment_method_string }}</p>
      </div>
    </div>

    <div class="px-4 py-6 border-bottom">
      <ng-container *ngFor="let item of value.product_invoice_list; let i = index">
        <div class="font-14">
          <div class="d-flex justify-content-between text-gray-900">
            <p class="mb-0">{{ item.product_name }} - {{ item.total_weight_unit }}</p>
            <p class="mb-0">{{ utilities.toRupiah(item.total_base_price) }}</p>
          </div>
          <div *ngIf="item.discount_percentage" class="d-flex justify-content-between text-gray-900">
            <p class="ms-3">{{ 'Sales Diskon ' + item.discount_percentage + '%' }}</p>
            <p class="text-danger">{{ '-' + utilities.toRupiah(item.discount_price) }}</p>
          </div>
        </div>
      </ng-container>
      <div *ngIf="value.subtotal_invoice" class="d-flex justify-content-between font-14 text-gray-900">
        <p class="text-capitalize fw-bold mb-0">Subtotal</p>
        <p class="fw-bold mb-0">{{ utilities.toRupiah(value.subtotal_invoice) }}</p>
      </div>
    </div>

    <!-- CBD DISCOUNT SECTION -->
    <div *ngIf="value.cbd_discount" class="px-4 py-6 border-bottom">
      <div class="d-flex justify-content-between font-14 text-gray-900">
        <p class="mb-0">{{ 'Discount Cash Before Delivery ' + '(' + value.cbd_discount + '%)' }}</p>
        <p class="mb-0">{{ '-' + utilities.toRupiah(value.cbd_discount_price) }}</p>
      </div>
    </div>

    <div *ngIf="value.total_invoice" class="px-4 py-6">
      <div class="d-flex font-14 justify-content-between">
        <p class="fw-bold mb-0">Total Harga <span class="text-gray-600 fw-normal">(Include PPN)</span></p>
        <p class="fw-bold mb-0">{{ utilities.toRupiah(value.total_invoice) }}</p>
      </div>
    </div>
  </ng-container>
</ng-template>
